<template>
    <v-container id="adminmesasexafinal-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>ADMINISTRACION DE MESAS DE EXÁMENES FINALES</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-tabs
                    centered
                    color="#4bc47f"
                    dark
                    icons-and-text
                    v-model="tabactivo"
                  >
                    <v-tabs-slider color="#2a6bbf" />
                    <v-tab href="#tab-1" key="Turnos" v-if="habilitadoturno">
                      Turnos
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-1" v-if="habilitadoturno">
                      <v-card flat>
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12" md="3" xl="3">
                              <v-select
                                v-model="filtros.anio"
                                :items="listaanios"
                                label="Año"
                                item-text="anio"
                                item-value="idanio"
                                v-on:change="actualizagrillaturnos"
                              />
                            </v-col>
                            <v-col cols="12" md="9" xl="9" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Listar Turnos"
                                @click="actualizagrillaturnos"
                                :disabled="!permisolectura"
                              >
                                <v-icon dark> mdi-magnify</v-icon>
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nuevo Turno"
                                @click="agregarturno"
                                :disabled="!permisoescritura"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-card>
                                <v-card-title>
                                  Turnos
                                </v-card-title>
                                <v-data-table
                                  :headers="columnasturnos"
                                  :items="listaturnos"
                                  :items-per-page="10"
                                  :footer-props="{
                                    'items-per-page-text': 'Filas por Página:',
                                    'items-per-page-all-text': 'Todos',
                                  }"
                                  item-key="idturno"
                                  class="elevation-1"
                                  dense
                                  no-data-text="Sin Registros"
                                  multi-sort
                                >
                                  <template v-slot:item.actions="{ item }">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          small
                                          icon
                                          color="blue"
                                          @click="editarturno(item)"
                                          v-bind="attrs"
                                          v-on="on"
                                          :disabled="!item.permitemodificar"
                                        >
                                          <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Modificar Turno</span>
                                    </v-tooltip>
                                    &nbsp;
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          small
                                          icon
                                          color="red"
                                          @click="quitarturno(item)"
                                          v-bind="attrs"
                                          v-on="on"
                                          :disabled="!item.permiteeliminar"
                                        >
                                          <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Eliminar Turno</span>
                                    </v-tooltip>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab
                      href="#tab-2"
                      key="Mesas"
                    >
                      Mesas
                      <v-icon>mdi-calendar-check-outline</v-icon>
                    </v-tab>
                    <v-tab-item value="tab-2">
                      <v-card flat>
                        <v-card-text>
                          <v-row row wrap>
                            <v-col cols="12" md="2" xl="2">
                              <v-select
                                v-model="filtrosmesa.anio"
                                :items="listaanios"
                                label="Año"
                                item-text="anio"
                                item-value="idanio"
                                v-on:change="cargaturnosparamesas"
                              />
                            </v-col>
                            <v-col cols="12" md="4" xl="4">
                              <v-select
                                v-model="filtrosmesa.idturno"
                                :items="listaturnosfiltro"
                                label="Turno"
                                item-text="nombrecompleto"
                                item-value="idturno"
                                v-on:change="seleccionaturnomesa"
                              />
                            </v-col>
                            <v-col cols="12" md="4" xl="4">
                              <v-select
                                v-model="filtrosmesa.idcarrera"
                                :items="listacarrerasfiltro"
                                label="Carrera"
                                item-text="carrera"
                                item-value="idcarrera"
                                v-on:change="actualizagrillamesas"
                              />
                            </v-col>
                            <v-col cols="12" md="2" xl="2" class="alineaizquierda">
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Listar Mesas"
                                @click="actualizagrillamesas"
                                :disabled="!permisolectura || filtrosmesa.idcarrera===0 || filtrosmesa.idturno===0"
                              >
                                <v-icon dark> mdi-magnify</v-icon>
                              </v-btn>
                              <v-btn
                                class="ma-2"
                                x-small
                                color="blue"
                                title="Nuevo Mesa"
                                @click="agregarmesa"
                                :disabled="!permisoescritura || filtrosmesa.idcarrera===0 || filtrosmesa.idturno===0"
                              >
                                <v-icon dark> mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row row wrap>
                            <v-col cols="12">
                              <v-card>
                                <v-card-title>
                                    Mesas de Exámenes Finales
                                </v-card-title>
                                <v-card-text>
                                  <v-data-table
                                    :headers="columnasmesas"
                                    :items="listamesas"
                                    :items-per-page="10"
                                    :footer-props="{
                                        'items-per-page-text': 'Filas por Página:',
                                        'items-per-page-all-text': 'Todos',
                                    }"
                                    item-key="idmesaexamen"
                                    class="elevation-1"
                                    dense
                                    no-data-text="Sin Registros"
                                    multi-sort
                                  >
                                    <template v-slot:item.actions="{ item }">
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            small
                                            icon
                                            color="blue"
                                            @click="editarmesa(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permitemodificar"
                                          >
                                            <v-icon>mdi-pencil</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Modificar Mesa</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permiteanular">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="red"
                                            @click="anularmesa(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permiteanular"
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Anular Mesa</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permiteactivar">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="green"
                                            @click="activarmesa(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permiteactivar"
                                          >
                                            <v-icon>mdi-check</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Activar Mesa</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permiteinscribir">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="green"
                                            @click="inscribir(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permiteinscribir"
                                          >
                                            <v-icon>mdi-account-plus</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Inscribir</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permitecalificar">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="violet"
                                            @click="calificarmesa(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permitecalificar"
                                          >
                                            <v-icon>mdi-numeric</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Calificar Mesa</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permitecerrar">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="orange"
                                            @click="cerrarmesa(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permitecerrar"
                                          >
                                            <v-icon>mdi-progress-close</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Cerrar Mesa</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-show="item.permiteimprimir">&nbsp;</span>
                                          <v-btn
                                            small
                                            icon
                                            color="seagreen"
                                            @click="imprimiracta(item)"
                                            v-bind="attrs"
                                            v-on="on"
                                            v-show="item.permiteimprimir"
                                          >
                                            <v-icon>mdi-printer</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Imprimir Acta Volante</span>
                                      </v-tooltip>
                                    </template>
                                    <template v-slot:item.tipomesa="{ item }">
                                      <v-chip :color="item.idtipomesa===1 ? 'green' : 'blue'" dark>
                                        <p class="textofilagrilla">{{ item.tipomesa }}</p>
                                      </v-chip>
                                    </template>
                                    <template v-slot:item.estado="{ item }">
                                      <v-chip :color="getcolorestadomesa(item.idestado)" dark>
                                        <p class="textofilagrilla">{{ item.estado }}</p>
                                      </v-chip>
                                    </template>
                                  </v-data-table>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            <div v-if="!mensajehtml">{{ mensajecuerpo }}</div>
            <div v-if="mensajehtml" v-html="mensajecuerpo"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevoturno" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevoturnotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarturno">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevoturno = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.anio"
                  :items="listaanios"
                  label="Año"
                  item-text="anio"
                  item-value="idanio"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.idtipoturno"
                  :items="listatiposturno"
                  label="Tipo"
                  item-text="nombre"
                  item-value="idtipoturno"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-menu
                  v-model="menufecturnodesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfturnodesde"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="turnoedited.desde"
                    @input="menufecturnodesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-menu
                  v-model="menufecturnohasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfturnohasta"
                      label="Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="turnoedited.hasta"
                    @input="menufecturnohasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="6" xl="6">
                <v-text-field
                  v-model="turnoedited.nombre"
                  label="Nombre"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.idsede"
                  :items="listasedes"
                  label="Sede"
                  item-text="sede"
                  item-value="idsede"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.resolucion"
                  label="Resolución"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.horascorteparainscripcion"
                  label="Hs Corte Inscripción"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.horasanularinscripcion"
                  label="Hs Anulación Inscripción"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-text-field
                  v-model="turnoedited.llamados"
                  label="Llamados"
                  type="number"
                />
              </v-col>
              <v-col cols="12" md="3" xl="3">
                <v-select
                  v-model="turnoedited.idestado"
                  :items="listaestadosturno"
                  label="Estado"
                  item-text="nombre"
                  item-value="idestado"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognuevamesa" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevamesatitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarmesa">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevamesa = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col class="TituloGrilla" cols="12" md="2" xl="2">
                Año: {{editedmesaextra.anio}}
              </v-col>
              <v-col class="TituloGrilla" cols="12" md="5" xl="5">
                Carrera: {{editedmesaextra.carrera}}
              </v-col>
              <v-col class="TituloGrilla" cols="12" md="5" xl="5">
                Turno: {{editedmesaextra.turno}}
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="1" xl="1">
                <v-select
                  v-model="mesaedited.llamado"
                  :items="listallamados"
                  label="LLamado"
                  item-text="llamado"
                  item-value="llamado"
                />
              </v-col>
              <v-col cols="12" md="2" xl="2">
                <v-menu
                  v-model="menufecmesa"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfmesa"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mesaedited.fecha"
                    @input="menufecmesa = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="1" xl="1">
                <v-menu
                  ref="menuhoramesa"
                  v-model="menuhoramesa"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="mesaedited.hora"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="mesaedited.hora"
                      label="Hora"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuhoramesa"
                    v-model="mesaedited.hora"
                    full-width
                    @click:minute="$refs.menuhoramesa.save(mesaedited.hora)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" xl="2">
                <v-menu
                  v-model="menuvenmesadesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvenmesadesde"
                      label="Venc Desde"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mesaedited.vencimientodesde"
                    @input="menuvenmesadesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" xl="2">
                <v-menu
                  ref="menuvhoramesadesde"
                  v-model="menuvhoramesadesde"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="mesaedited.vhora"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="mesaedited.vhoradesde"
                      label="Hora Desde"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuvhoramesadesde"
                    v-model="mesaedited.vhoradesde"
                    full-width
                    @click:minute="$refs.menuvhoramesadesde.save(mesaedited.vhoradesde)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" xl="2">
                <v-menu
                  v-model="menuvenmesahasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalvenmesahasta"
                      label="Venc Hasta"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mesaedited.vencimientohasta"
                    @input="menuvenmesahasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2" xl="2">
                <v-menu
                  ref="menuvhoramesahasta"
                  v-model="menuvhoramesahasta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="mesaedited.vhorahasta"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="mesaedited.vhorahasta"
                      label="Hora Hasta"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menuvhoramesahasta"
                    v-model="mesaedited.vhorahasta"
                    full-width
                    @click:minute="$refs.menuvhoramesahasta.save(mesaedited.vhorahasta)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-select
                  v-model="mesaedited.idasignatura"
                  :items="listaasignaturas"
                  label="Asignatura"
                  item-text="nombre"
                  item-value="idasignatura"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idpresidente"
                  :items="listadocentes"
                  label="Presidente"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idvocal1"
                  :items="listadocentes"
                  label="Vocal 1"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
              <v-col cols="12" md="4" xl="4">
                <v-select
                  v-model="mesaedited.idvocal2"
                  :items="listadocentes"
                  label="Vocal 2"
                  item-text="docente"
                  item-value="iddocente"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-select
                  v-model="mesaedited.idtipomesa"
                  :items="listatiposmesa"
                  label="Tipo Mesa"
                  item-text="tipomesa"
                  item-value="idtipomesa"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogcalificar" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Calificaciones de la Mesa de Examen Final
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardacalificacion">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialogcalificar = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-card>
              <v-card-subtitle>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Carrera: {{calificaextras.carrera}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Turno: {{calificaextras.turno}} --- Llamado: {{calificaextras.llamado}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Asignatura: {{calificaextras.asignatura}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Fecha y Hora: {{calificaextras.fecha}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal letraroja" v-if="calificaextras.idtipomesa===2">
                    Examen Integrador
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-spacer />
                  </v-col>
                </v-row>
              </v-card-subtitle>
              <v-card-text>
                <v-row class="text-center">
                  <v-col cols="12">
                    <p><strong style="color: black">0 - AUSENTE</strong> -- <strong style="color: red">1-5 DESAPROBADO</strong> -- <strong style="color: green">6-10 APROBADO</strong></p>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-data-table
                      :headers="columnasfinales"
                      :items="listafinales"
                      :items-per-page="listafinales.length"
                      :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idalumno"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                    >
                      <template v-slot:item.notaescrito="{ item }">
                        <v-text-field
                          v-model="item.notaescrito"
                          label="Escrito"
                          type="number"
                          :rules="numberRule"
                          class="alineacentro"
                        />
                      </template>
                      <template v-slot:item.notaoral="{ item }">
                        <v-text-field
                          v-model="item.notaoral"
                          label="Oral"
                          type="number"
                          :rules="numberRule"
                          class="alineacentro"
                        />
                      </template>
                      <template v-slot:item.notafinal="{ item }">
                        <v-text-field
                          v-model="item.notafinal"
                          label="Final"
                          type="number"
                          :rules="numberRule"
                          class="alineacentro"
                        />
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialoginscribir" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Inscripción a la Mesa de Examen
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                    color="red darken-1"
                    text
                    @click="cerrarinscribir"
                >
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-card>
              <v-card-subtitle>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Carrera: {{insextras.carrera}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Turno: {{insextras.turno}} --- LLamado: {{insextras.llamado}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Asignatura: {{insextras.asignatura}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal">
                    Fecha y Hora: {{insextras.fecha}}
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12" class="TituloGrillaNormal letraroja" v-if="insextras.idtipomesa===2">
                    Examen Integrador
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-spacer />
                  </v-col>
                </v-row>
              </v-card-subtitle>
              <v-card-text>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-btn
                      class="ma-2"
                      x-small
                      color="green"
                      title="Nuevo Inscripto"
                      @click="agregarinscripto"
                    >
                      <v-icon dark> mdi-account-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-data-table
                      :headers="columnasinscripciones"
                      :items="listainscripciones"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idalumno"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              icon
                              color="red"
                              @click="borrarinscripto(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="item.notafinal!=null && item.notafinal!=0"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Borrar Inscripto</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogselalumno" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Seleccione el Estudiante
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialogselalumno = false"
                >
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-card>
              <v-card-text>
                <v-row row wrap>
                  <v-col cols="12">
                    <v-data-table
                      :headers="columnasalumnos"
                      :items="listaalumnos"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                      }"
                      item-key="idalumno"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip v-if="item.permiteseleccionar" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              icon
                              color="green"
                              @click="seleccionaalumno(item)"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-arrow-right-box</v-icon>
                            </v-btn>
                          </template>
                          <span>Seleccionar</span>
                        </v-tooltip>
                        <v-chip v-else color="red" dark>
                          <p class="textofilagrilla">{{ item.observaseleccionar }}</p>
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
  import axios from "@/axios";
  import ConfirmDlg from "../Confirm.vue";
  export default {
    name: "adminmesasexafinal",
    components: {
      ConfirmDlg: ConfirmDlg
    },
    data() {
      return {
        loading: false,
        usuario: '',
        permisolectura: false,
        permisoescritura: false,
        nromodulo: 15,
        idrol: 0,
        roles: [],
        dialogmensaje: false,
        mensajetitulo: '',
        mensajecuerpo: '',
        mensajehome: false,
        mensajehtml: false,
        tabactivo: 'Mesas',
        listaanios: [],
        filtros: {
          anio: (new Date()).getFullYear()
        },
        columnasturnos: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 70
          },
          {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idturno",
            width: 40
          },
          {
            text: "Sede",
            align: "center",
            sortable: true,
            value: "sede",
            width: 90
          },
          {
            text: "Tipo",
            align: "center",
            sortable: true,
            value: "tipoturno",
            width: 100
          },
          {
            text: "Nombre",
            align: "center",
            sortable: true,
            value: "nombre",
            width: 120
          },
          {
            text: "Desde",
            align: "center",
            sortable: true,
            value: "desdestr",
            width: 85
          },
          {
            text: "Hasta",
            align: "center",
            sortable: true,
            value: "hastastr",
            width: 85
          },
          {
            text: "Llamados",
            align: "center",
            sortable: true,
            value: "cantidadllamados",
            width: 80
          },
          {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 90
          }
        ],
        listaturnos: [],
        buscaturno: '',
        dialognuevoturno: false,
        dialognuevoturnotitulo:'',
        listatiposturno: [],
        turnoedited: {
            idturno: 0,
            anio: (new Date()).getFullYear(),
            idtipoturno: 1,
            desde: '',
            hasta: '',
            nombre: '',
            resolucion: '',
            horascorteparainscripcion: 48,
            horasanularinscripcion: 24,
            llamados: 2,
            idestado: 1,
            usuario: ''
        },
        menufecturnodesde: false,
        menufecturnohasta: false,
        listaestadosturno: [],
        columnasmesas: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 190
          },
          {
            text: "ID",
            align: "center",
            sortable: false,
            value: "idmesaexamen",
            width: 60
          },
          {
            text: "LLam",
            align: "center",
            sortable: false,
            value: "llamado",
            width: 80
          },
          {
            text: "Fecha",
            align: "center",
            sortable: false,
            value: "fechadmy",
            width: 110
          },
          /* {
            text: "Carrera",
            align: "center",
            sortable: true,
            value: "carrera",
            width: 80
          }, */
          {
            text: "Ciclo",
            align: "center",
            sortable: false,
            value: "ciclo",
            width: 75
          },
          {
            text: "Asignatura",
            align: "center",
            sortable: false,
            value: "asignatura",
            width: 140
          },
          {
            text: "Presidente",
            align: "center",
            sortable: false,
            value: "presidente",
            width: 140
          },
          {
            text: "V Desde",
            align: "center",
            sortable: false,
            value: "vencimientodesdedmy",
            width: 100
          },
          {
            text: "V Hasta",
            align: "center",
            sortable: false,
            value: "vencimientohastadmy",
            width: 100
          },
          {
            text: "Tipo",
            align: "center",
            sortable: false,
            value: "tipomesa",
            width: 50
          },
          {
            text: "Insc",
            align: "center",
            sortable: false,
            value: "inscriptos",
            width: 75
          },
          {
            text: "Calif",
            align: "center",
            sortable: false,
            value: "calificados",
            width: 75
          },
          {
            text: "Estado",
            align: "center",
            sortable: false,
            value: "estado",
            width: 90
          }
        ],
        listamesas: [],
        filtrosmesa: {
          anio: (new Date()).getFullYear(),
          idturno: 0,
          idcarrera: 0
        },
        listaturnosfiltro: [],
        listacarrerasfiltro: [],
        dialognuevamesa: false,
        dialognuevamesatitulo: '',
        menufecmesa: false,
        menuvenmesadesde: false,
        menuvenmesahasta: false,
        mesaedited: {
          idmesa: 0,
          idturno: 0,
          llamado: 0,
          fecha: '',
          hora: '',
          vencimientodesde: '',
          vhoradesde: '',
          vencimientohasta: '',
          vhorahasta: '',
          idasignatura: 0,
          idpresidente: 0,
          idvocal1: 0,
          idvocal2: 0,
          idtipomesa: 0,
          usuario: ''
        },
        listaasignaturas: [],
        listadocentes: [],
        listallamados: [
          {llamado: 1},
          {llamado: 2}
        ],
        dialogcalificar: false,
        columnasfinales: [
          {
            text: "Orden",
            align: "center",
            sortable: true,
            value: "orden",
            width: 50
          },
          {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "dnialumno",
            width: 50
          },
          {
            text: "Estudiante",
            align: "left",
            sortable: true,
            value: "alumno",
            width: 250
          },
          {
            text: "Año",
            align: "center",
            sortable: true,
            value: "anio",
            width: 70
          },
          {
            text: "Escrito",
            align: "center",
            sortable: true,
            value: "notaescrito",
            width: 70
          },
          {
            text: "Oral",
            align: "center",
            sortable: true,
            value: "notaoral",
            width: 70
          },
          {
            text: "Final",
            align: "center",
            sortable: true,
            value: "notafinal",
            width: 70
          }
        ],
        listafinales: [],
        calificaextras: {
          carrera: '',
          turno: '',
          llamado: '',
          asignatura: '',
          fecha: '',
          idmesa: 0,
          idtipomesa: 0
        },
        dialoginscribir: false,
        insextras: {
          carrera: '',
          turno: '',
          llamado: '',
          asignatura: '',
          fecha: '',
          idmesa: 0,
          idtipomesa: 0
        },
        columnasinscripciones: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 70
          },
          {
            text: "Orden",
            align: "center",
            sortable: true,
            value: "orden",
            width: 80
          },
          {
            text: "DNI",
            align: "center",
            sortable: true,
            value: "dnialumno",
            width: 100
          },
          {
            text: "Estudiante",
            align: "left",
            sortable: true,
            value: "alumno",
            width: 300
          },
          {
            text: "Año",
            align: "center",
            sortable: true,
            value: "anio",
            width: 100
          }
        ],
        listainscripciones: [],
        dialogselalumno: false,
        columnasalumnos: [
          {
            text: 'Op.',
            value: 'actions',
            sortable: false,
            width: 70
          },
          {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idalumno",
            width: 50
          },
          {
            text: "Apellido",
            align: "center",
            sortable: true,
            value: "apellido",
            width: 200
          },
          {
            text: "Nombre",
            align: "center",
            sortable: true,
            value: "nombre",
            width: 200
          },
          {
            text: "Documento",
            align: "center",
            sortable: true,
            value: "nrodoc",
            width: 110
          },
          {
            text: "Sede",
            align: "center",
            sortable: true,
            value: "sede",
            width: 80
          }
        ],
        listaalumnos: [],
        listasedes: [],
        editedmesaextra: {
            anio: 0,
            carrera: '',
            turno: ''
        },
        listacarrerasoriginal: [],
        menuhoramesa: false,
        menuvhoramesadesde: false,
        menuvhoramesahasta: false,
        idmesainscripcion: 0,
        editedinsc: {
          llamado: 0,
          idmesaexamen: 0,
          idalumno: 0,
          usuario: 0
        },
        listatiposmesa: [{idtipomesa: 1, tipomesa: 'Regular'},{idtipomesa: 2, tipomesa: 'Integrador'}],
        habilitadoturno: true,
        numberRule: [
            v=> v >= 0 || 'El valor debe ser mayor o igual a cero (ausente)'
        ]
      }
    },
    mounted() {
      this.loading=true;
      this.usuario= localStorage.getItem('user')
      var permisos= JSON.parse(localStorage.getItem('permisos'));
      var rolesuser = localStorage.getItem("rolesuserid").split(',');
      rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
      });
      var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
      if(existeper.length===0)
      {
        this.loading=false;
        this.mostrarmensaje('Error','No tiene permisos para acceder a este módulo.',true);
      }else{
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        if(this.roles.includes(2)) {
          this.habilitadoturno=false;
        }else{
          this.habilitadoturno=true;
        }
        this.completacombos();
        //this.loading=false;
      }
    },
    methods: {
      mostrarmensaje(titulo, cuerpo, home, html) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.mensajehome= home!=null ? home : false;
        this.mensajehtml= html!=null ? html : false;
        this.dialogmensaje = true;
      },
      completacombos () {
        this.loading=true;
        var anioactual=(new Date()).getFullYear()+1;
        var inicio=2010;
        for(inicio=2010;inicio<=anioactual;inicio++){
          this.listaanios.push({idanio: inicio, anio: inicio});
        }
        axios.get('referenciales/tipoturnoexafinal').then((result) => {
          this.listatiposturno = result.data.datos;
          axios.get('referenciales/estadoturnoexafinal').then((result) => {
            this.listaestadosturno = result.data.datos;
            var parametroscarrera= JSON.stringify({iddocente: 0});
            axios.post("referenciales/PostCarreras",parametroscarrera, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0){
                this.listacarrerasoriginal = result.data.datos.filter(c=> c.idnivel===4);
                this.listacarrerasfiltro = this.listacarrerasoriginal.slice();
                this.filtrosmesa.idcarrera= this.listacarrerasfiltro.length>0 ? this.listacarrerasfiltro[0].idcarrera : 0;
                var i=0;
                this.listasedes=[];
                for(i=0;i<=this.listacarrerasfiltro.length-1;i++){
                  if(this.listasedes.filter(s=> s.idsede===this.listacarrerasfiltro[i].idsede).length===0){
                    this.listasedes.push({idsede: this.listacarrerasfiltro[i].idsede, sede: this.listacarrerasfiltro[i].sede});
                  }
                }
                this.actualizagrillaturnos(true);
              }else{
                this.loading = false;
                this.mostrarmensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje('Error', error, false);
            });
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje('Error', error, false);
          })
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      actualizagrillaturnos (actualizaturnosencombomesas) {
        this.loading=true;
        axios.get('examenfinal/ListaTurnos/' + this.usuario + '/' + this.filtros.anio.toString() + '/0/0').then((result) => {
          if(result.data.resultado===0)
          {
            this.listaturnos = result.data.datos;
            if(actualizaturnosencombomesas===true){
              this.cargaturnosparamesas();
            }else{
              this.loading = false;
            }
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      agregarturno () {
        this.loading=true;
        this.dialognuevoturnotitulo='NUEVO TURNO DE EXAMEN FINAL';
        this.turnoedited= {
            idturno: 0,
            anio: (new Date()).getFullYear(),
            idtipoturno: 1,
            desde: '',
            hasta: '',
            nombre: '',
            resolucion: '',
            horascorteparainscripcion: 48,
            horasanularinscripcion: 24,
            llamados: 2,
            idestado: 1,
            idsede: 1,
            usuario: this.usuario
        };
        this.dialognuevoturno= true;
        this.loading=false;
      },
      editarturno (item) {
        this.loading=true;
        this.dialognuevoturnotitulo='EDITANDO EL TURNO DE EXAMEN FINAL N° ' + item.idturno;
        this.turnoedited= {
            idturno: item.idturno,
            anio: item.año,
            idtipoturno: item.idtipoturno,
            desde: item.desdeymdstr,
            hasta: item.hastaymdstr,
            nombre: item.nombre,
            resolucion: item.resolucionnota,
            horascorteparainscripcion: item.horasanteriorparainscripcion,
            horasanularinscripcion: item.horasanteriorparaanularinscripcion,
            llamados: item.cantidadllamados,
            idestado: item.idestado,
            idsede: item.idsede,
            usuario: this.usuario
        };
        this.dialognuevoturno= true;
        this.loading=false;
      },
      async quitarturno (item) {
        if (await this.$refs.confirm.open("Eliminar Turno", "Está seguro que desea eliminar el turno?")) {
          this.loading = true;
          var turno = { idturno: item.idturno, usuario: this.usuario };
          axios.put("examenfinal/PutEliminarTurno", turno, { headers: { "Content-Type": "application/json"},}).then((result) => {
            if (result.data.resultado === 0) {
              this.actualizagrillaturnos();
            } else {
              this.loading = false;
              this.mostrarmensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje("Error", error, false);
          });
        }
      },
      guardarturno () {
        this.loading=true;
        this.turnoedited.llamados= parseInt(this.turnoedited.llamados);
        this.turnoedited.horascorteparainscripcion= parseInt(this.turnoedited.horascorteparainscripcion);
        this.turnoedited.horasanularinscripcion= parseInt(this.turnoedited.horasanularinscripcion);
        const turno = JSON.stringify(this.turnoedited);
        axios.post("examenfinal/PostTurno", turno, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevoturno= false;
            this.actualizagrillaturnos(true);
          }else{
            this.loading = false;
            this.mostrarmensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje("Error", error, false);
        });
      },
      actualizagrillamesas () {
        this.loading=true;
        axios.get('examenfinal/ListaMesasFinales/' + this.usuario + '/' + this.filtrosmesa.anio.toString() + '/' + this.filtrosmesa.idturno.toString() + '/' + this.filtrosmesa.idcarrera.toString()).then((result) => {
          if(result.data.resultado===0)
          {
            this.listamesas = result.data.datos;
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      cargaturnosparamesas() {
        axios.get('examenfinal/ListaTurnos/' + this.usuario + '/' + this.filtrosmesa.anio.toString() + '/0/0').then((result) => {
          if(result.data.resultado===0)
          {
            this.listaturnosfiltro = result.data.datos;
            if(this.listaturnosfiltro.length>0){
              this.filtrosmesa.idturno= this.listaturnosfiltro[0].idturno;
              var lista= this.listacarrerasoriginal.filter(c=> c.idsede===this.listaturnosfiltro[0].idsede);
              this.listacarrerasfiltro= lista;
            }
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        })
      },
      agregarmesa () {
        var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, anio: 0 });
        axios.post("examenfinal/PostDocentesxAnioCarrera",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listadocentes = result.data.datos;
            var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, iddocente: 0, anio: 0 });
            axios.post("cursada/PostAsignaturas",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0) {
                this.listaasignaturas = result.data.datos;
                var fechora= new Date();
                var hora= (fechora.getHours().toString().length>1 ? fechora.getHours().toString() : '0' + fechora.getHours().toString()) + ':' + (fechora.getMinutes().toString().length>1 ? fechora.getMinutes().toString() : '0' + fechora.getMinutes().toString());
                this.mesaedited= {
                  idmesa: 0,
                  idturno: this.filtrosmesa.idturno,
                  llamado: 1,
                  fecha: this.fechaFormatoYMD(fechora),
                  hora: hora,
                  vencimientodesde: this.fechaFormatoYMD(fechora),
                  vhoradesde: hora,
                  vencimientohasta: this.fechaFormatoYMD(fechora),
                  vhorahasta: hora,
                  idasignatura: this.listaasignaturas.length>0 ? this.listaasignaturas[0].idasignatura : 0,
                  idpresidente: 0,
                  idvocal1: 0,
                  idvocal2: 0,
                  idtipomesa: 1,
                  usuario: this.usuario
                };
                this.editedmesaextra= {
                  anio: this.filtrosmesa.anio,
                  carrera: this.listacarrerasfiltro.filter(c=> c.idcarrera===this.filtrosmesa.idcarrera)[0].carrera,
                  turno: this.listaturnosfiltro.filter(c=> c.idturno===this.filtrosmesa.idturno)[0].nombrecompleto
                };
                this.dialognuevamesatitulo='Nueva Mesa de Exámen Final';
                this.dialognuevamesa= true;
                this.loading = false;
              }else{
                this.loading = false;
                this.mostrarmensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje('Error', error, false);
            });
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      editarmesa (item) {
        var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, anio: 0 });
        axios.post("examenfinal/PostDocentesxAnioCarrera",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listadocentes = result.data.datos;
            var parametros= JSON.stringify({idcarrera: this.filtrosmesa.idcarrera, iddocente: 0, anio: 0 });
            axios.post("cursada/PostAsignaturas",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
              if(result.data.resultado===0) {
                this.listaasignaturas = result.data.datos;
                this.mesaedited= {
                  idmesa: item.idmesaexamen,
                  idturno: item.idturno,
                  llamado: item.llamado,
                  fecha: this.fechaFormatoYMD(new Date(item.fechaymd)),
                  hora: item.hora,
                  vencimientodesde: this.fechaFormatoYMD(new Date(item.vencimientodesdeymd)),
                  vhoradesde: item.vencimientohoradesde,
                  vencimientohasta: this.fechaFormatoYMD(new Date(item.vencimientohastaymd)),
                  vhorahasta: item.vencimientohorahasta,
                  idasignatura: item.idasignatura,
                  idpresidente: item.idpresidente!=null ? item.idpresidente : 0,
                  idvocal1: item.idvocal1!=null ? item.idvocal1 : 0,
                  idvocal2: item.idvocal2!=null ? item.idvocal2 : 0,
                  idtipomesa: item.idtipomesa,
                  usuario: this.usuario
                };
                this.editedmesaextra= {
                  anio: this.filtrosmesa.anio,
                  carrera: this.listacarrerasfiltro.filter(c=> c.idcarrera===this.filtrosmesa.idcarrera)[0].carrera,
                  turno: this.listaturnosfiltro.filter(c=> c.idturno===item.idturno)[0].nombrecompleto
                };
                this.dialognuevamesatitulo='Editando Mesa de Exámen Final ID: ' + item.idmesaexamen;
                this.dialognuevamesa= true;
                this.loading = false;
              }else{
                this.loading = false;
                this.mostrarmensaje('Error', result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje('Error', error, false);
            });
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      guardarmesa () {
        var valido= '';
        valido= this.validarmesa();
        if(valido.length===0) {
          this.loading=true;
          this.mesaedited.idpresidente = this.mesaedited.idpresidente!=null ? this.mesaedited.idpresidente : 0;
          this.mesaedited.idvocal1 = this.mesaedited.idvocal1!=null ? this.mesaedited.idvocal1 : 0;
          this.mesaedited.idvocal2 = this.mesaedited.idvocal2!=null ? this.mesaedited.idvocal2 : 0;
          const mesa = JSON.stringify(this.mesaedited);
          axios.post("examenfinal/PostMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              this.dialognuevamesa= false;
              this.actualizagrillamesas(true);
            }else{
              this.loading = false;
              this.mostrarmensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje("Error", error, false);
          });
        }else{
          this.loading = false;
          this.mostrarmensaje("Error", valido, false);
        }
      },
      validarmesa () {
        var valido='';
        if(this.mesaedited.fecha===null || this.mesaedited.fecha==='') {
          valido= 'Debe ingresar fecha de la mesa';
        }
        if(this.mesaedited.hora===null || this.mesaedited.hora==='') {
          valido= 'Debe ingresar hora de la mesa';
        }
        if(this.mesaedited.vencimientodesde===null || this.mesaedited.vencimientodesde==='') {
          valido= 'Debe ingresar fecha de vencimiento desde de inscripción a la mesa';
        }
        if(this.mesaedited.vencimientohasta===null || this.mesaedited.vencimientohasta==='') {
          valido= 'Debe ingresar fecha de vencimiento hasta de inscripción a la mesa';
        }
        if(this.mesaedited.vhoradesde===null || this.mesaedited.vhoradesde==='') {
          valido= 'Debe ingresar hora desde del vencimiento de inscripción a la mesa';
        }
        if(this.mesaedited.vhorahasta===null || this.mesaedited.vhorahasta==='') {
          valido= 'Debe ingresar hora hasta del vencimiento de inscripción a la mesa';
        }
        /* if(this.mesaedited.idpresidente===null || this.mesaedited.idpresidente===0) {
          valido= 'Debe ingresar fecha de vencimiento de inscripción a la mesa';
        } */
        return valido;
      },
      async anularmesa (item) {
        var pregunta='';
        var titulo= '';
        if(item.idestado===1){
          titulo= 'Confirmar Borrado de la Mesa';
          pregunta= "Esta seguro de querer borrar la mesa ID " + item.idmesaexamen.toString() + " ?";
        }else{
          titulo= 'Confirmar Anulación de la Mesa';
          pregunta= "Esta seguro de querer anular la mesa ID " + item.idmesaexamen.toString() + " ?";
        }
        if (await this.$refs.confirm.open(titulo, pregunta)) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostAnulaMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.mostrarmensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje("Error", error, false);
            });
          }
      },
      async activarmesa (item) {
        if (await this.$refs.confirm.open('Activar Mesa', 'Esta seguro de activar la mesa de examen? los alumnos podran verla e inscribirse a partir de la fecha de inicio del turno.')) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostActivarMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.mostrarmensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje("Error", error, false);
            });
          }
      },
      calificarmesa (item) {
        this.loading=true;
        var parametros= JSON.stringify({ idmesa: item.idmesaexamen, usuario: this.usuario });
        axios.post("examenfinal/PostListaFinales",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.calificaextras= {
                carrera: item.carrera,
                turno: item.turno,
                llamado: item.llamado,
                asignatura: item.asignatura,
                fecha: item.fechadmy,
                idmesa: item.idmesaexamen,
                idtipomesa: item.idtipomesa
            };
            this.listafinales = result.data.datos;
            this.dialogcalificar= true;
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      guardacalificacion () {
        var valido=this.validarfinales();
        if(valido.length===0) {
          this.loading=true;
          const finales = JSON.stringify({idmesa: this.calificaextras.idmesa, finales: this.listafinales, usuario: this.usuario });
          axios.post("examenfinal/PostCalificar", finales, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              this.dialogcalificar= false;
              this.actualizagrillamesas(true);
            }else{
              this.loading = false;
              this.mostrarmensaje("Error", result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje("Error", error, false);
          });
        }else{
          this.mostrarmensaje("Error", valido, false, true);
        }
      },
      validarfinales () {
        var res='';
        var i=0;
        for(i=0;i<this.listafinales.length;i++){
          if(this.listafinales[i].notafinal===null || this.listafinales[i].notafinal.toString().length===0 || parseFloat(this.listafinales[i].notafinal)<0)
          {
            res= res.length>0 ? res + '<br />* Alumno: ' + this.listafinales[i].alumno + ' debe Ingresar Nota Final válida.' : '* Alumno: ' + this.listafinales[i].alumno + ': debe Ingresar Nota Final válida.';
          }else{
            if(parseFloat(this.listafinales[i].notafinal)===0) {
              if(this.listafinales[i].notaoral===null || this.listafinales[i].notaoral.toString().length===0 || parseFloat(this.listafinales[i].notaoral)===0){
                if(this.listafinales[i].notaescrito===null || this.listafinales[i].notaescrito.toString().length===0 || parseFloat(this.listafinales[i].notaescrito)===0){
                  this.listafinales[i].notafinal= 0;
                  this.listafinales[i].notaoral= 0;
                  this.listafinales[i].notaescrito= 0;
                }else{
                  res= res.length>0 ? res + '<br />** Alumno: ' + this.listafinales[i].alumno + ': Nota Escrito no coincide con Nota Final.' : '** Alumno: ' + this.listafinales[i].alumno + ': Nota Escrito no coincide con Nota Final.';
                }
              }else{
                res= res.length>0 ? res + '<br />** Alumno: ' + this.listafinales[i].alumno + ': Nota Oral no coincide con Nota Final.' : '** Alumno: ' + this.listafinales[i].alumno + ': Nota Oral no coincide con Nota Final.';
              }
            }else{
              this.listafinales[i].notafinal=parseFloat(this.listafinales[i].notafinal);
              if(this.listafinales[i].notaoral===null || this.listafinales[i].notaoral.toString().length===0 || parseFloat(this.listafinales[i].notaoral)>0)
              {
                this.listafinales[i].notaoral= this.listafinales[i].notaoral!=null && this.listafinales[i].notaoral.toString().length>0 ? parseFloat(this.listafinales[i].notaoral) : null;
              }else{
                res= res.length>0 ? res + '<br />* Alumno: ' + this.listafinales[i].alumno + ': Nota Oral no coincide con Nota Final.' : '* Alumno: ' + this.listafinales[i].alumno + ': Nota Oral no coincide con Nota Final.';
              }

              if(this.listafinales[i].notaescrito===null || this.listafinales[i].notaescrito.toString().length===0 || parseFloat(this.listafinales[i].notaescrito)>0)
              {
                this.listafinales[i].notaescrito= this.listafinales[i].notaescrito!=null && this.listafinales[i].notaescrito.toString().length>0 ? parseFloat(this.listafinales[i].notaescrito) : null;
              }else{
                res= res.length>0 ? res + '<br />* Alumno: ' + this.listafinales[i].alumno + ': Nota Escrito no coincide con Nota Final.' : '* Alumno: ' + this.listafinales[i].alumno + ': Nota Escrito no coincide con Nota Final.';
              }
            }
          }
        }
        return res;
      },
      async cerrarmesa (item) {
        if (await this.$refs.confirm.open('Cerrar Mesa', 'Esta seguro de cerrar la mesa de examen? Ya no podran hacer modificaciones en los datos ni en las calificaciones.')) {
            const mesa = JSON.stringify({idmesa: item.idmesaexamen, usuario: this.usuario});
            axios.post("examenfinal/PostCerrarMesa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizagrillamesas();
              }else{
                this.loading = false;
                this.mostrarmensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje("Error", error, false);
            });
        }
      },
      imprimiracta (item) {
        this.loading = true;
        axios.post("reportes/GetReporte", {idreporte: 10, formato: 'PDF', nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idmesa", valor: item.idmesaexamen.toString()} ] },{ headers: { "Content-Type": "application/json" }}).then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            if(item.idestado<5){
              this.loading = false;
              window.open(result.data, "_blank");
            }else{
              this.preguntamarcaimpresion(result.data, item.idmesaexamen);
            }
          } else {
            this.mostrarmensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje("Error", error, false);
        });
      },
      async preguntamarcaimpresion (pdf, idmesa) {
        if (await this.$refs.confirm.open('Marcar como impresa', 'Desea marcar como impresa el acta una vez abierto el pdf?')) {
          const mesa = JSON.stringify({idmesa: idmesa, usuario: this.usuario});
          axios.post("examenfinal/PostMarcaImpresionActa", mesa, { headers: {"Content-Type": "application/json", }}).then((result) => {
            if (result.data.resultado === 0) {
              window.open(pdf, "_blank");
              this.actualizagrillamesas();
            }else{
              this.loading = false;
              window.open(pdf, "_blank");
            }
          }).catch(() => {
            this.loading = false;
            window.open(pdf, "_blank");
          });

        }else{
          this.loading = false;
          window.open(pdf, "_blank");
        }
      },
      fechaFormatoYMD(date) {
        return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
      },
      inscribir (item) {
        this.loading=true;
        this.insextras={
            carrera: item.carrera,
            turno: item.turno,
            llamado: item.llamado,
            asignatura: item.asignatura,
            fecha: item.fechadmy,
            idmesa: item.idmesaexamen,
            idtipomesa: item.idtipomesa
        };
        var parametros= JSON.stringify({ idmesa: item.idmesaexamen, usuario: this.usuario });
        axios.post("examenfinal/PostListaFinales",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listainscripciones = result.data.datos;
            this.dialoginscribir= true;
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      actualizainscripciones () {
        var parametros= JSON.stringify({ idmesa: this.insextras.idmesa, usuario: this.usuario });
        axios.post("examenfinal/PostListaFinales",parametros, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listainscripciones = result.data.datos;
            this.loading = false;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      agregarinscripto () {
        this.loading= true;
        var mesa= JSON.stringify({ idmesa: this.insextras.idmesa, usuario: this.usuario });
        axios.post("examenfinal/PostListaAlumnosParaInscribirMesa",mesa, { headers: { "Content-Type": "application/json"}}).then((result) => {
          if(result.data.resultado===0) {
            this.listaalumnos= result.data.datos;
            this.loading= false;
            this.dialogselalumno= true;
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      async borrarinscripto (item) {
        if (await this.$refs.confirm.open('Borrar Inscripto', 'Esta seguro de borrar el inscripto a la mesa de examen?')) {
            this.loading= true;
            const inscripcion = JSON.stringify({idmesaexamen: this.insextras.idmesa,idalumno: item.idalumno, usuario: this.usuario});
            axios.post("examenfinal/PostBorrarInscripcionexamenfinal", inscripcion, { headers: {"Content-Type": "application/json", }}).then((result) => {
              if (result.data.resultado === 0) {
                this.actualizainscripciones();
              }else{
                this.loading = false;
                this.mostrarmensaje("Error", result.data.resultadomensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.mostrarmensaje("Error", error, false);
            });
        }
      },
      seleccionaalumno (item) {
        this.loading= true;
        this.editedinsc= {
          llamado: this.insextras.llamado,
          idmesaexamen: this.insextras.idmesa,
          idalumno: item.idalumno,
          usuario: this.usuario
        };
        var inscripcion= JSON.stringify(this.editedinsc);
        axios.post("examenfinal/PostInscripcionMesa",inscripcion, { headers: { "Content-Type": "application/json",}}).then((result) => {
          if(result.data.resultado===0){
            this.dialogselalumno=false;
            this.actualizainscripciones();
          }else{
            this.loading = false;
            this.mostrarmensaje('Error', result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.mostrarmensaje('Error', error, false);
        });
      },
      seleccionaturnomesa () {
        this.loading=true;
        var idsedeturno=  this.listaturnosfiltro.filter(t=> t.idturno===this.filtrosmesa.idturno)[0].idsede;
        var lista= this.listacarrerasoriginal.filter(c=> c.idsede===idsedeturno);
        this.listacarrerasfiltro= lista;
        this.filtrosmesa.idcarrera= lista[0].idcarrera;
        this.actualizagrillamesas();
      },
      cerrarinscribir () {
        this.loading= true;
        this.dialoginscribir = false;
        this.actualizagrillamesas();
      },
      getcolorestadomesa (estado) {
        if (estado === 1) {return "grey";}
        else if (estado === 2) {return "green";}
        else if (estado === 3) {return "black";}
        else if (estado === 4) {return "blue";}
        else if (estado === 5) {return "orange";}
        else if (estado === 6) {return "violet";}
      },
    },
    computed: {
      fechalocalfturnodesde: function () {
        if(this.turnoedited.desde!=null && this.turnoedited.desde!='')
        {
          var fecha=new Date(this.turnoedited.desde)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalfturnohasta: function () {
        if(this.turnoedited.hasta!=null && this.turnoedited.hasta!='')
        {
          var fecha=new Date(this.turnoedited.hasta)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalfmesa: function () {
        if(this.mesaedited.fecha!=null && this.mesaedited.fecha!='')
        {
          var fecha=new Date(this.mesaedited.fecha)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalvenmesadesde: function () {
        if(this.mesaedited.vencimientodesde!=null && this.mesaedited.vencimientodesde!='')
        {
          var fecha=new Date(this.mesaedited.vencimientodesde)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
      fechalocalvenmesahasta: function () {
        if(this.mesaedited.vencimientohasta!=null && this.mesaedited.vencimientohasta!='')
        {
          var fecha=new Date(this.mesaedited.vencimientohasta)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      },
    }
  }
</script>
<style>
/* .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 4px;
} */

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.TituloGrillaNormal {
  font-family: Tahoma;
  font-size: large;
  font-weight: bold;
}
</style>